import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { authService } from '../../services/authService';
import '../../styles/admin/AdminLayout.css';

export function AdminLayout() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const clearAdminSession = () => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('admin_access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user_type');
          localStorage.removeItem('device_fingerprint');
          localStorage.removeItem('remember_me');
          localStorage.removeItem('token_expires');
        };

        // Check if user is admin type
        if (authService.isAuthenticated() && authService.isAdmin()) {
          // Verify admin token with backend
          const result = await authService.verifyAdmin();
          if (result.success) {
            setUser(result.admin);
            setIsAdmin(true);
          } else {
            // Token invalid, clear storage
            clearAdminSession();
          }
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('access_token');
        localStorage.removeItem('admin_access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_type');
        localStorage.removeItem('device_fingerprint');
        localStorage.removeItem('remember_me');
        localStorage.removeItem('token_expires');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogout = async () => {
    try {
      await authService.adminLogout();
    } catch (error) {
      console.error('Logout error:', error);
    }
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('access_token');
    localStorage.removeItem('admin_access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_type');
    localStorage.removeItem('device_fingerprint');
    localStorage.removeItem('remember_me');
    localStorage.removeItem('token_expires');
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="admin-access-denied">
        <div className="access-denied-content">
          <h1>Access Denied</h1>
          <p>You don't have admin privileges to view this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <AdminSidebar user={user} onLogout={handleLogout} />
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
